import themeDark from './_themeDark'
import themeLight from './_themeLight'

export default {
  themes: {
    ...themeDark,
    ...themeLight
  }
}
